import React, { useEffect, useState } from 'react';
import { Smartphone, X } from 'lucide-react';

const KEY = 'ios_push_hint_shown';

// Avviso una-tantum su iPhone (app installata): chiudere l'app dal multitasking blocca le notifiche push (limite iOS)
const IosPushHint = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    const standalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
    if (!isIOS || !standalone || localStorage.getItem(KEY)) return;
    // Attende almeno 8s e che il banner "Attiva le Notifiche" non sia visibile (evita sovrapposizione)
    let elapsed = 0;
    const iv = setInterval(() => {
      elapsed += 2000;
      if (elapsed >= 8000 && !document.querySelector('[data-testid="enable-notifications-btn"]')) {
        clearInterval(iv);
        setVisible(true);
      }
    }, 2000);
    return () => clearInterval(iv);
  }, []);

  const chiudi = () => {
    localStorage.setItem(KEY, new Date().toISOString());
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div data-testid="ios-push-hint" className="fixed bottom-4 right-4 left-4 z-50 animate-in slide-in-from-bottom-4 duration-300">
      <div className="bg-gray-900 text-white rounded-xl shadow-2xl border border-gray-700 p-4">
        <div className="flex items-start gap-3">
          <Smartphone className="h-5 w-5 text-amber-400 flex-shrink-0 mt-0.5" />
          <div className="flex-1 text-sm">
            <p className="font-semibold mb-1">Notifiche su iPhone: non chiudere l'app dal multitasking</p>
            <p className="text-gray-300">
              Per uscire usa il gesto Home e lascia l'app in background. Se la scorri via dal multitasking, iPhone
              blocca le notifiche finché non la riapri (limite di iOS per le web app).
            </p>
          </div>
          <button data-testid="ios-push-hint-close" onClick={chiudi} className="text-gray-400 hover:text-white" aria-label="Chiudi">
            <X className="h-5 w-5" />
          </button>
        </div>
        <button
          data-testid="ios-push-hint-ok"
          onClick={chiudi}
          className="mt-3 w-full bg-amber-500 hover:bg-amber-400 text-gray-900 font-semibold py-2 rounded-lg text-sm"
        >
          Ho capito
        </button>
      </div>
    </div>
  );
};

export default IosPushHint;
